<template>
  <div class="delete-tab-modal-wrapper">
    <CustomModal @onClose="$emit('action', { action: 'close' })">
      <div class="delete-tab-modal">
        <div class="card-header">
          <h5>
            TAB <strong>{{ tabName }}</strong> LÖSCHEN
          </h5>
          <p>Wie wollen Sie mit der Inhalt des Tabs umgehen ?</p>
        </div>
        <div class="tab-actions-wrapper">
          <div
            v-for="(action, indx) in getActions"
            :key="indx"
            @click="onActionClick(action.key)"
            class="inner-card"
            :class="{ disabled: disabledKeys.includes(action.key) }"
          >
            <img :src="action.img" />
            <p>{{ action.label }}</p>
          </div>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '../modals/CustomModal.vue';

export default {
  name: 'DeleteTabModal',
  props: {
    tabName: {
      type: String,
      default: '',
      required: true,
    },
    disabledKeys: {
      type: Array,
      default: () => [],
      required: false,
    },
    deleteModalMoveText: {
      type: String,
      default: 'Inhalt zurückverschieben',
    },
  },
  methods: {
    onActionClick(key) {
      if (!this.disabledKeys.includes(key))
        this.$emit('action', { action: key });
    },
  },
  computed: {
    getActions() {
      return [
        {
          key: 'delete',
          label: 'Inhalt entfernen',
          img: require('../../assets/img/tab-modal-delete.svg'),
        },
        {
          key: 'move',
          label: this.deleteModalMoveText,
          img: require('../../assets/img/tab-modal-move.svg'),
        },
      ];
    },
  },
  components: { CustomModal },
};
</script>
<style scoped>
.delete-tab-modal-wrapper ::v-deep .content {
  padding: 60px 85px;
}

.delete-tab-modal-wrapper .delete-tab-modal .card-header h5 {
  color: #333343;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0 0 21px;
}

.delete-tab-modal-wrapper .delete-tab-modal .card-header p {
  color: #333343;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.delete-tab-modal-wrapper .delete-tab-modal .tab-actions-wrapper {
  gap: 9px;
  display: flex;
  align-items: center;
  margin: 24px 0 0;
}
.delete-tab-modal-wrapper .delete-tab-modal .tab-actions-wrapper .inner-card {
  padding: 23px;
  display: flex;
  flex-direction: column;
  gap: 38px;
  border-radius: 14px;
  border: 0.5px solid #ddd;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  min-height: 138px;
}

.delete-tab-modal-wrapper
  .delete-tab-modal
  .tab-actions-wrapper
  .inner-card:hover {
  background: #f4f4f6;
}

.delete-tab-modal-wrapper
  .delete-tab-modal
  .tab-actions-wrapper
  .inner-card
  img {
  width: 23px;
  height: 23px;
}

.delete-tab-modal-wrapper .delete-tab-modal .tab-actions-wrapper .inner-card p {
  color: #5f6979;
  font-size: 13px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 0;
  max-width: 173px;
}

.delete-tab-modal-wrapper
  .delete-tab-modal
  .tab-actions-wrapper
  .inner-card.disabled {
  background: #f4f4f6;
  pointer-events: none;
}
</style>
